const TIER_ONE_FEE = 300;
const TIER_TWO_FEE = 450;
const TIER_THREE_FEE = 565;

export const calculateUnits = (procedureLength: string | number) => {
  if (procedureLength === null || procedureLength === undefined || procedureLength === "") {
    return 0;
  }

  const minutes =
    typeof procedureLength === "number"
      ? procedureLength
      : parseInt(String(procedureLength), 10);

  if (!Number.isFinite(minutes) || minutes <= 0) {
    return 0;
  }

  return Math.ceil(minutes / 15);
};

export const getTierForMonthlyUnits = (totalUnits: number) => {
  if (totalUnits >= 20) {
    return 3;
  }

  if (totalUnits >= 12) {
    return 2;
  }

  if (totalUnits >= 4) {
    return 1;
  }

  return 0;
};

export const getTierFee = (tier: number) => {
  if (tier === 1) {
    return TIER_ONE_FEE;
  }

  if (tier === 2) {
    return TIER_TWO_FEE;
  }

  if (tier === 3) {
    return TIER_THREE_FEE;
  }

  return 0;
};
